import React from 'react';
import { Form } from 'react-bootstrap';

type Epic = {
  key: string;
  summary: string;
};

type Props = {
  epics: Epic[];
  onSelect: (epicKey: string) => void;
};

const EpicSelector: React.FC<Props> = ({ epics, onSelect }) => (
  <Form>
    <Form.Group controlId="epicSelect">
      <Form.Label>Select an Epic</Form.Label>
      <Form.Control as="select" onChange={(e) => onSelect(e.target.value)}>
        <option value="">Choose...</option>
        {epics.map((epic) => (
          <option key={epic.key} value={epic.key}>{epic.key} - {epic.summary}</option>
        ))}
      </Form.Control>
    </Form.Group>
  </Form>
);

export default EpicSelector;
